import * as React from "react";
import { FlexContainer } from "../grid/flexcontainer";
import { componentTranslations } from "./i18n";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const offerStateLabelClass = css({
    whiteSpace: "nowrap",
    fontSize: "13px",
    fontWeight: 500,
    borderRadius: "1px",
    color: getThemeColorVar("white", undefined),
    backgroundColor: getThemeColorVar("secondary1", "default"),
});
export const OfferStateLabel = (props) => {
    const translations = componentTranslations();
    return (React.createElement("div", { className: cx(offerStateLabelClass) },
        React.createElement(FlexContainer, { paddingX: "base", paddingY: "sm", "md-justify": "center", "md-align": "center" },
            React.createElement("span", null, translations.offerState[props.offerState]))));
};
export default OfferStateLabel;
//# sourceMappingURL=offerstatelabel.js.map